import { SummaryTable, type SummaryTableColumn, type SummaryTableRow } from '@olytic/foundation';

import { hoursText, monthLabel } from './model';

export interface GridColumn {
  key: string;
  label: string;
}

/** Months down the left, a column per person, then a set-apart total; read-only. */
export function MonthGrid({
  caption, months, people, hours, empty,
}: {
  caption: string;
  months: string[];
  people: GridColumn[];
  /** Hours in a month for a person column. */
  hours: (month: string, column: string) => number;
  empty: string;
}): JSX.Element {
  const figure = (n: number) => (n ? hoursText(n) : { text: '–', tone: 'muted' as const });
  const columns: SummaryTableColumn[] = [
    { key: 'month', label: 'Month', numeric: false },
    ...people.map((p) => ({ key: `p:${p.key}`, label: p.label })),
    { key: 'total', label: 'Total', total: true },
  ];
  const rowOf = (month: string): SummaryTableRow => {
    const cells: SummaryTableRow['cells'] = { month: monthLabel(month) };
    let total = 0;
    for (const p of people) {
      const n = hours(month, p.key);
      total += n;
      cells[`p:${p.key}`] = figure(n);
    }
    cells.total = figure(total);
    return { key: month, cells };
  };
  const totals: SummaryTableRow['cells'] = { month: 'Total' };
  let all = 0;
  for (const p of people) {
    const n = months.reduce((sum, m) => sum + hours(m, p.key), 0);
    all += n;
    totals[`p:${p.key}`] = figure(n);
  }
  totals.total = figure(all);

  return (
    <SummaryTable
      caption={caption}
      columns={columns}
      rows={months.length ? [...months.map(rowOf), { key: 'total', cells: totals, total: true }] : []}
      empty={empty}
    />
  );
}
